import styled from 'styled-components';
import { getColor } from '../colors/colors';

export const Label = styled.label`
    font-size: 0.75rem;
    color: ${getColor('gray', '900')};
`;
